(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-product-editorial"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('card-product-editorial-form')) {
    customElements.define('card-product-editorial-form', class extends HTMLElement {
      constructor() {
        super();
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.handleClick = this.handleClick.bind(this);
      }

      connectedCallback() {
        const dataNode = this.querySelector('[data-editorial-variants]');
        this.variants = dataNode ? JSON.parse(dataNode.textContent || '[]') : [];
        this.colorButtons = Array.from(this.querySelectorAll('[data-color-value]'));
        this.sizeButtons = Array.from(this.querySelectorAll('[data-size-value]'));
        this.addButton = this.querySelector('[data-add-to-cart]');
        this.variantInput = this.querySelector('[data-selected-variant-input]');
        this.labelNode = this.querySelector('[data-add-to-cart-label]');
        this.productLinks = this.closest('.card-product').querySelectorAll('.product-link');
        this.image = this.closest('.card-product').querySelector('.product-first-image img');
        this.selectedColor = this.dataset.selectedColor || '';
        this.selectedSize = this.dataset.selectedSize || '';
        this.addLabel = this.dataset.addLabel || 'Add to cart';
        this.soldoutLabel = this.dataset.soldoutLabel || 'Sold out';
        this.colorOptionPosition = Number(this.dataset.colorOptionPosition || 0);
        this.sizeOptionPosition = Number(this.dataset.sizeOptionPosition || 0);
        this.currentVariant = null;

        this.addEventListener('click', this.handleClick);
        this.syncState();
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleClick);
      }

      handleClick(event) {
        const colorButton = event.target.closest('[data-color-value]');
        if (colorButton && !colorButton.disabled) {
          event.preventDefault();
          this.selectedColor = colorButton.dataset.colorValue || '';
          this.syncState(true);
          return;
        }

        const sizeButton = event.target.closest('[data-size-value]');
        if (sizeButton && !sizeButton.disabled) {
          event.preventDefault();
          this.selectedSize = sizeButton.dataset.sizeValue || '';
          this.syncState();
          return;
        }

        const addButton = event.target.closest('[data-add-to-cart]');
        if (addButton && !addButton.disabled) {
          event.preventDefault();
          this.addSelectedVariant();
        }
      }

      syncState(fromColorChange = false) {
        if (this.colorButtons.length > 0 && !this.selectedColor) {
          const firstEnabledColor = this.colorButtons.find((button) => !button.disabled);
          if (firstEnabledColor) this.selectedColor = firstEnabledColor.dataset.colorValue || '';
        }

        if (this.sizeButtons.length > 0) {
          this.updateSizeAvailability();
          const activeSizeAvailable = this.sizeButtons.some((button) => {
            return button.dataset.sizeValue === this.selectedSize && !button.disabled;
          });

          if (!activeSizeAvailable || fromColorChange) {
            const firstEnabledSize = this.sizeButtons.find((button) => !button.disabled);
            this.selectedSize = firstEnabledSize ? firstEnabledSize.dataset.sizeValue || '' : '';
          }
        }

        this.currentVariant = this.findVariant();
        this.updateColorState();
        this.updateSizeState();
        this.updateMedia();
        this.updateLinks();
        this.updateAddButton();
      }

      getOptionValue(variant, position) {
        if (position === 1) return variant.option1 || '';
        if (position === 2) return variant.option2 || '';
        if (position === 3) return variant.option3 || '';
        return '';
      }

      findVariant() {
        const exactAvailableMatch = this.variants.find((variant) => {
          let matches = true;

          if (this.colorOptionPosition > 0 && this.selectedColor) {
            matches = matches && this.getOptionValue(variant, this.colorOptionPosition) === this.selectedColor;
          }

          if (this.sizeOptionPosition > 0 && this.selectedSize) {
            matches = matches && this.getOptionValue(variant, this.sizeOptionPosition) === this.selectedSize;
          }

          return matches && variant.available;
        });

        if (exactAvailableMatch) return exactAvailableMatch;

        const exactMatch = this.variants.find((variant) => {
          let matches = true;

          if (this.colorOptionPosition > 0 && this.selectedColor) {
            matches = matches && this.getOptionValue(variant, this.colorOptionPosition) === this.selectedColor;
          }

          if (this.sizeOptionPosition > 0 && this.selectedSize) {
            matches = matches && this.getOptionValue(variant, this.sizeOptionPosition) === this.selectedSize;
          }

          return matches;
        });

        if (exactMatch) return exactMatch;

        const firstAvailable = this.variants.find((variant) => variant.available);
        return firstAvailable || this.variants[0] || null;
      }

      hasAvailableVariantFor(colorValue, sizeValue) {
        return this.variants.some((variant) => {
          let matches = variant.available;

          if (matches && this.colorOptionPosition > 0 && colorValue) {
            matches = this.getOptionValue(variant, this.colorOptionPosition) === colorValue;
          }

          if (matches && this.sizeOptionPosition > 0 && sizeValue) {
            matches = this.getOptionValue(variant, this.sizeOptionPosition) === sizeValue;
          }

          return matches;
        });
      }

      updateSizeAvailability() {
        this.sizeButtons.forEach((button) => {
          const sizeValue = button.dataset.sizeValue || '';
          let hasAvailable = button.dataset.initiallyAvailable !== 'false';

          if (this.colorButtons.length > 1 && this.selectedColor) {
            hasAvailable = this.hasAvailableVariantFor(this.selectedColor, sizeValue);
          }

          button.disabled = !hasAvailable;
          button.classList.toggle('is-soldout', !hasAvailable);
          button.setAttribute('aria-disabled', hasAvailable ? 'false' : 'true');
        });
      }

      updateColorState() {
        this.colorButtons.forEach((button) => {
          const isActive = (button.dataset.colorValue || '') === this.selectedColor;
          button.classList.toggle('active', isActive);
          button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
      }

      updateSizeState() {
        this.sizeButtons.forEach((button) => {
          const isActive = (button.dataset.sizeValue || '') === this.selectedSize;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
      }

      updateMedia() {
        const activeColorButton = this.colorButtons.find((button) => {
          return (button.dataset.colorValue || '') === this.selectedColor;
        });

        if (!activeColorButton || !this.image) return;

        const newImageSrcset = activeColorButton.dataset.srcset;
        const newImageSrc = activeColorButton.dataset.src;

        if (newImageSrcset) this.image.srcset = newImageSrcset;
        if (newImageSrc) this.image.src = newImageSrc;
      }

      updateLinks() {
        const nextUrl = this.currentVariant?.url || this.dataset.productUrl;
        if (!nextUrl) return;

        this.productLinks.forEach((link) => {
          link.href = nextUrl;
        });
      }

      updateAddButton() {
        if (!this.addButton || !this.labelNode) return;

        const available = Boolean(this.currentVariant && this.currentVariant.available);
        this.addButton.disabled = !available;
        this.labelNode.textContent = available ? this.addLabel : this.soldoutLabel;

        if (this.variantInput) {
          this.variantInput.value = this.currentVariant ? String(this.currentVariant.id) : '';
        }
      }

      async addSelectedVariant() {
        if (!this.currentVariant || !this.currentVariant.available || !this.addButton) return;

        const spinner = this.addButton.querySelector('.loading__spinner');
        this.addButton.disabled = true;
        this.addButton.classList.add('loading');
        if (spinner) spinner.classList.remove('hidden');

        try {
          const formData = new FormData();
          formData.append('id', this.currentVariant.id);
          formData.append('quantity', 1);

          if (this.cart?.getSectionsToRender) {
            const sections = this.cart.getSectionsToRender().map((section) => section.id);
            formData.append('sections', sections.join(','));
            formData.append('sections_url', window.location.pathname);
            this.cart.setActiveElement?.(document.activeElement);
          }

          const response = await fetch(`${routes.cart_add_url}.js`, {
            method: 'POST',
            headers: {
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: formData
          });

          if (!response.ok) {
            const text = await response.text();
            throw new Error(text);
          }

          const data = await response.json();

          if (data.status) {
            throw new Error(data.message || data.description || 'Unable to add item');
          }

          if (this.cart?.renderContents) {
            this.cart.renderContents(data);
          } else {
            window.location = window.routes.cart_url;
          }
        } catch (error) {
          console.error(error);
        } finally {
          if (spinner) spinner.classList.add('hidden');
          this.addButton.classList.remove('loading');
          this.updateAddButton();

          if (this.cart && this.cart.classList.contains('is-empty')) {
            this.cart.classList.remove('is-empty');
          }
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["card-product-overlay"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('card-product-overlay-form')) {
    customElements.define('card-product-overlay-form', class extends HTMLElement {
      connectedCallback() {
        const dataNode = this.querySelector('[data-overlay-variants]');
        this.variants = dataNode ? JSON.parse(dataNode.textContent || '[]') : [];
        this.colorButtons = [...this.querySelectorAll('[data-color-value]')];
        this.sizeButtons = [...this.querySelectorAll('[data-size-value]')];
        this.toggleButtons = [...this.querySelectorAll('[data-overlay-toggle]')];
        this.panel = this.querySelector('[data-overlay-panel]');
        this.addButton = this.querySelector('[data-add-to-cart]');
        this.variantInput = this.querySelector('[data-selected-variant-input]');
        this.labelNode = this.querySelector('[data-add-to-cart-label]');
        this.selectedColor = this.dataset.selectedColor || '';
        this.selectedSize = this.dataset.selectedSize || '';
        this.colorPosition = Number(this.dataset.colorOptionPosition || 0);
        this.sizePosition = Number(this.dataset.sizeOptionPosition || 0);
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.addEventListener('click', (event) => this.handleClick(event));
        this.syncState();
      }
      optionValue(variant, position) { return variant[`option${position}`] || ''; }
      handleClick(event) {
        const toggle = event.target.closest('[data-overlay-toggle]');
        if (toggle) { event.preventDefault(); this.toggle(); return; }
        const color = event.target.closest('[data-color-value]');
        if (color && !color.disabled) { event.preventDefault(); this.selectedColor = color.dataset.colorValue || ''; this.syncState(true); return; }
        const size = event.target.closest('[data-size-value]');
        if (size && !size.disabled) { event.preventDefault(); this.selectedSize = size.dataset.sizeValue || ''; this.syncState(); return; }
        if (event.target.closest('[data-add-to-cart]') && !this.addButton.disabled) { event.preventDefault(); this.addSelectedVariant(); }
      }
      toggle() { const open = !this.classList.contains('is-open'); this.classList.toggle('is-open', open); this.toggleButtons.forEach((button) => button.setAttribute('aria-expanded', String(open))); this.panel?.setAttribute('aria-hidden', String(!open)); }
      availableFor(color, size) { return this.variants.some((variant) => variant.available && (!this.colorPosition || this.optionValue(variant, this.colorPosition) === color) && (!this.sizePosition || this.optionValue(variant, this.sizePosition) === size)); }
      findVariant() { return this.variants.find((variant) => variant.available && (!this.colorPosition || this.optionValue(variant, this.colorPosition) === this.selectedColor) && (!this.sizePosition || this.optionValue(variant, this.sizePosition) === this.selectedSize)) || this.variants.find((variant) => variant.available) || this.variants[0]; }
      syncState(colorChanged = false) {
        this.sizeButtons.forEach((button) => { const available = !this.colorPosition || !this.selectedColor ? button.dataset.initiallyAvailable !== 'false' : this.availableFor(this.selectedColor, button.dataset.sizeValue || ''); button.disabled = !available; });
        if (this.sizeButtons.length && (colorChanged || !this.sizeButtons.some((button) => button.dataset.sizeValue === this.selectedSize && !button.disabled))) this.selectedSize = this.sizeButtons.find((button) => !button.disabled)?.dataset.sizeValue || '';
        this.currentVariant = this.findVariant();
        this.colorButtons.forEach((button) => { const active = button.dataset.colorValue === this.selectedColor; button.classList.toggle('is-active', active); button.setAttribute('aria-pressed', String(active)); });
        this.sizeButtons.forEach((button) => { const active = button.dataset.sizeValue === this.selectedSize; button.classList.toggle('is-active', active); button.setAttribute('aria-pressed', String(active)); });
        const available = Boolean(this.currentVariant?.available); this.addButton.disabled = !available; this.labelNode.textContent = available ? this.dataset.addLabel : this.dataset.soldoutLabel; this.variantInput.value = this.currentVariant?.id || '';
      }
      async addSelectedVariant() {
        if (!this.currentVariant?.available) return;
        this.addButton.disabled = true;
        try {
          const formData = new FormData(); formData.append('id', this.currentVariant.id); formData.append('quantity', 1);
          if (this.cart?.getSectionsToRender) { formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id).join(',')); formData.append('sections_url', window.location.pathname); }
          const response = await fetch(`${routes.cart_add_url}.js`, { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest' }, body: formData });
          const data = await response.json(); if (!response.ok || data.status) throw new Error(data.message || 'Unable to add item');
          if (this.cart?.renderContents) { this.cart.classList.remove('is-empty'); this.cart.renderContents(data); } else window.location = routes.cart_url;
          
        } catch (error) { console.error(error); } finally { this.syncState(); }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
